/** Copyright �2013 Renoworks, Inc. All rights reserved. www.Renoworks.com
 *
 * @param {jQuery} $ A reference to the jQuery object.
 */
(function ($) {
  Renoworks = window.Renoworks || {};
  Renoworks.LayerHandler = new LayerHandler();

  function LayerHandler() {
    this.paintLayers = ['Trim', 'Soffit', 'Fascia'];
    this.openingLayers = [];
  }

  /**
     * Load the layer regions for the current project and do actions for each layer
     */
  LayerHandler.prototype.loadLayerRegions = function () {
    Renoworks.ProjectController.setRegion(null);
    var layers = Renoworks.ProjectController.getLayers();
    var deleteButton;
    for (var i = 0; i < layers.length; i++) {
      var layer = layers[i];
      if (layer.type == 'Foreground') { continue; }
      layer.perspective.setColor(Renoworks.Masking.maskColor);
      layer.perspective.setGridLines(false);
      layer.perspective.showDimensions(false);
      layer.perspective.showVanishingPoints(false);
      layer.perspective.handleSize = { radius: 7, bigRadius: 9 };
      if (layer.perspective.points.length == 5) {
        layer.perspective.isGarageDoor = true;
      }
      layer.perspective.dontFill = false;
      layer.selected = false;

      $('#project_image').append(getDeleteButton(layer));
    }
  };

  /**
     * Shows the layer highlight for the layer passed in
     * If a product is applied to the layer, don't show the fill
     *
     * @param {Layer}
     */
  LayerHandler.prototype.showLayerHighlights = function () {
    Renoworks.MaskingController.eraseRasterCanvas();
    var layers = Renoworks.ProjectController.getLayers();
    $.each(layers, function (i, l) {
      if (l.type != 'Foreground') {
        Renoworks.MaskingController.showSingleLayerHighlight(l);
        if ($('#sub_header_menu li[data-label="prepare"]').hasClass('selected')) {
          // During masking, show the masks and handles, even if there is a render.
          l.perspective.dontFill = false;
          if (!Renoworks.MaskingController.getDragging()) {
            l.perspective.showHandles();
          } else {
            l.perspective.hideHandles();
          }
        }
      }
    });
  };

  /**
     * Set the layer as the current region in the project controller and darken the highlight
     *
     * @param {Layer}
     */
  LayerHandler.prototype.setSelectedLayer = function (layer, hideBorder) {
    // If the layer is not already selected, set it as selected and unselect the others
    var oldLayerName = Renoworks.ProjectController.getRegion();
    if (oldLayerName != layer.name) {
      if (Renoworks.ProjectHandler.isMasking()) {
        layer.selected = true;
        if (oldLayerName) {
          var oldLayer = Renoworks.ProjectController.getLayersForName(oldLayerName)[0];
          oldLayer.perspective.border = false;
          oldLayer.selected = false;
        }
        Renoworks.ProjectController.setRegion(layer.name);
      } else {
        if (hideBorder) {
          layer.perspective.border = false;
        } else {
          layer.perspective.border = true;
        }
        layer.selected = true;
        if (oldLayerName) {
          var oldLayer = Renoworks.ProjectController.getLayersForName(oldLayerName)[0];
          oldLayer.perspective.border = false;
          oldLayer.selected = false;
        }
        Renoworks.ProjectController.setRegion(layer.name);
        Renoworks.LayerHandler.showLayerHighlights();
        Renoworks.ProductHandler.propagateLayerProductOptions();
        if (!Renoworks.mobile) { // on mobile, this will bring up product panel which is shouldn't, we wait till the user click the preview button
          Renoworks.ProductHandler.setSelectedProduct();
        }
      }
    } else if (!Renoworks.ProjectHandler.isMasking()) {
      Renoworks.LayerHandler.clearSelectedLayer();
    }
  };

  /**
     * De-select the currently selected layer
     */
  LayerHandler.prototype.clearSelectedLayer = function () {
    var layer = Renoworks.ProjectController.getLayersForName(Renoworks.ProjectController.getRegion())[0];
    if (layer) {
      layer.perspective.border = false;
      Renoworks.LayerHandler.showLayerHighlights();
      Renoworks.ProjectController.setRegion(null);
    }
  };

  LayerHandler.prototype.initLayerButtons = function () {
    $('#prepare_photo').on('click', '.grid_cell, .btn', function () {
      if ($(this).hasClass('door_size')) {
        $('.door_size.selected').removeClass('selected');
        $(this).addClass('selected');
        switch ($(this).attr('data-label')) {
          case 'Single':
            $('.add_shape_wrapper .door_shape .grid_swatch.single').show();
            $('.add_shape_wrapper .door_shape .grid_swatch.double').hide();
            break;
          case 'Double':
            $('.add_shape_wrapper .door_shape .grid_swatch.double').show();
            $('.add_shape_wrapper .door_shape .grid_swatch.single').hide();
            break;
          default:
            break;
        }
        $('.add_shape_wrapper').addClass('visible');
      } else if ($(this).hasClass('door_shape')) {
        var w,
          h,
          points,
          filter,
          doorSize = $('.door_size.selected').attr('data-label');

        switch (doorSize) {
          case 'Single':
            w = Renoworks.ProjectController.getProjectWidth() * 0.2;
            h = w;
            filter = 'Single Door';
            break;
          case 'Double':
            w = Renoworks.ProjectController.getProjectWidth() * 0.3;
            h = Renoworks.ProjectController.getProjectHeight() * 0.3;
            filter = 'Double Door';
            break;
          default:
            break;
        }

        switch ($(this).attr('data-label')) {
          case 'Rectangle':
            points = 4;
            break;
          case 'Arched':
            points = 5;
            break;
          case 'Cut Corners':
            points = 6;
            break;
          default:
            break;
        }

        w *= Renoworks.MaskingController.getScale();
        h *= Renoworks.MaskingController.getScale();

        addNewOpening(w, h, points, filter);

        $('.finish').addClass('visible');
      } else if ($(this).hasClass('btn')) {
        Renoworks.LayerHandler.finishPrepareScene();
      }
    });
  };

  /**
     * Add a new opening layer to the current project.
     *
     * @param wid {Number} opening width
     * @param hgt {Number} opening height
     * @param productFilter {String}
     * @param {Number} numPoints: Number of points that should be in the polygon: 4 - Rectangle, 5 - Arched, 6 - Cut Corners
     */
  function addNewOpening(wid, hgt, numPoints, productFilter) {
    var layerType = 'Door';

    // Add layer to the project/canvas
    var layerId = Renoworks.MaskingController.newLayer(true, layerType, wid, hgt, Renoworks.Masking.maskColor, false, false, false, true, numPoints);

    var layer = Renoworks.ProjectController.getLayerByID(layerId);
    var layerName = zeroPad(layerId, 2) + ' ' + layerType;
    layer.name = layerName;
    layer.productFilter = productFilter;
    layer.perspective.handleSize = { radius: 6, bigRadius: 8 };

    Renoworks.MaskingController.showAllPerspectives(true);
    Renoworks.MaskingController.disableDrawing();
    Renoworks.ProjectController.setRegion(layerName);

    $('#project_image').append(getDeleteButton(layer).show());
  }

  function getDeleteButton(layer) {
    var topRightX = layer.perspective.points[1].x;
    var topRightY = layer.perspective.points[1].y;
    var scaledPoint = getScaledPoint({ x: topRightX, y: topRightY });

    var deleteButton = $('.masking_button.delete:first').clone();
    deleteButton.attr('data-layer-id', layer.id);

    deleteButton.on('click touchend', function () {
      var html = Renoworks.LocaleController.getValueForKey('del_layer');
      var title = Renoworks.LocaleController.getValueForKey('delete_layer');
      var sidePanel = $('#prepare_photo');
      var classes = 'notice';
      var buttons = [];
      var button = new Renoworks.Button();
      button.name = Renoworks.LocaleController.getValueForKey('yes');
      button.classes = 'btn';
      button.callback = function () {
        deleteLayer(layer.id, true);
        deleteButton.remove();
        sidePanel.css({
          display: 'block',
        });
      };
      buttons.push(button);
      button = new Renoworks.Button();
      button.name = Renoworks.LocaleController.getValueForKey('no');
      button.classes = 'btn';
      button.callback = function () {
        Renoworks.Notify.hide();
        sidePanel.css({
          display: 'block',
        });
      };
      buttons.push(button);

      Renoworks.Notify.show(html, title, classes, buttons);
    });

    // top = scaledPoint.y + 'px';
    // left = (scaledPoint.x + 20) + 'px';
    deleteButton.css({
      top: scaledPoint.y + 'px',
      left: (scaledPoint.x + 20) + 'px',
    });

    return deleteButton;
  }

  LayerHandler.prototype.showDoorOnlyView = function (e) {
    $('.project_image .masking_button.door_only').remove();
    var layers = Renoworks.ProjectController.getLayers();

    for (var i = 0; i < layers.length; i++) {
      var layer = layers[i];

      var product = Renoworks.ProjectController.getProductForRegion(layer.name);
      var productApplied = product != null && product.data != null && product.data != '';
      if (layer.type != 'Foreground' && productApplied) {
        var topRightX = layer.perspective.points[1].x;
        var topRightY = layer.perspective.points[1].y;

        var topLeftX = layer.perspective.points[3].x;

        var top;
        var left;
        if (Renoworks.mobile) {
          var scaledPoint = getScaledPoint({ x: topLeftX + ((topRightX - topLeftX) / 2) - ($('.door_only:first').outerWidth() / 2), y: topRightY });
          top = (scaledPoint.y - $('.door_only:first').height() - 20) + 'px';
          left = (scaledPoint.x) + 'px';
        } else {
          var scaledPoint = getScaledPoint({ x: topRightX, y: topRightY });
          top = scaledPoint.y + 'px';
          left = (scaledPoint.x + 20) + 'px';
        }

        var doorOnlyButton = $('.masking_button.door_only:first').clone();
        doorOnlyButton.attr('data-layer-id', layer.id);
        if (Renoworks.mobile) {
          doorOnlyButton.addClass('mobile');
        }

        (function (layer) {
          doorOnlyButton.on('click', function (e) {
            e.stopPropagation();

            if (Renoworks.ProjectController.getRegion() != layer.name) {
              Renoworks.LayerHandler.setSelectedLayer(layer, true);
            }

            $('#door_only .door_image').hide();
            $('#door_only .door_image[data-id="' + layer.id + '"]').show();

            $('#door_only').css('left', $('.page:visible').outerWidth() + 'px');
            $('#door_only').removeClass('hidden');
          });
        }(layer));

        doorOnlyButton.css({
          top: top,
          left: left,
        });

        $('#project_image').append(doorOnlyButton.show());
      }
    }
  };

  /**
     * Completes the masking process and transitions into applying product
     */
  LayerHandler.prototype.finishPrepareScene = function (dontOpen) {
    Renoworks.ProjectController.saveProject(null, true);
    $('.add_shape_wrapper, .finish').removeClass('visible');
    Renoworks.LayerHandler.hideMaskingButtons();
    Renoworks.MaskingController.setDesignMode(true);
    Renoworks.MaskingController.hideAllPerspectives();
    Renoworks.LayerHandler.clearSelectedLayer();
    Renoworks.ProjectHandler.setProjectDesignMode(true);
    if (!dontOpen) {
      Renoworks.ViewController.showModal('select_product');
    }
    Renoworks.ProductHandler.showFirstTab();
    Renoworks.LayerHandler.showLayerHighlights();

    if (Renoworks.ViewController.isUrlProduct()) {
      Renoworks.ViewController.applyUrlProduct();
    }
  };

  function deleteLayer(layerId) {
    Renoworks.ProjectController.setRegion(null);
    Renoworks.ProjectController.clearProductForRegion(Renoworks.ProjectController.getLayerByID(layerId).name); // remove the product so that it doesnt show up on print reports
    Renoworks.MaskingController.deleteLayer(layerId, true);
    Renoworks.ProjectController.saveProject(null, true);

    if (Renoworks.ProjectController.getLayers().length == 0) {
      $('.finish').removeClass('visible');
    }

    Renoworks.Notify.hide();
  }

  /**
     * Adds leading zeros to a number
     *
     * @param {Number}
     * @param {Number}
     */
  function zeroPad(num, places) {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join('0') + num;
  }

  LayerHandler.prototype.resizeMaskingButtons = function () {
    var layers = Renoworks.ProjectController.getLayers();
    for (var i = 0; i < layers.length; i++) {
      var layer = layers[i];
      var deleteButton = $('#project_image .masking_button[data-layer-id="' + layer.id + '"]');

      if (deleteButton) {
        var topRightX = layer.perspective.points[1].x;
        var topRightY = layer.perspective.points[1].y;
        var topLeftX = layer.perspective.points[3].x;

        var top;
        var left;
        if (Renoworks.mobile) {
          var scaledPoint = getScaledPoint({ x: topLeftX + ((topRightX - topLeftX) / 2) - ($('.door_only:first').outerWidth() / 2), y: topRightY });
          top = (scaledPoint.y - $('.door_only:first').height() - 20) + 'px';
          left = (scaledPoint.x) + 'px';
        } else {
          var scaledPoint = getScaledPoint({ x: topRightX, y: topRightY });
          top = scaledPoint.y + 'px';
          left = (scaledPoint.x + 20) + 'px';
        }

        // top: scaledPoint.y + 'px',
        // left: (scaledPoint.x + 20) + 'px'
        deleteButton.css({
          top: top,
          left: left,
        });
      }
    }
  };

  LayerHandler.prototype.showMaskingButtons = function () {
    $('.masking_button.delete').not(':first').show();
    $('.masking_button.door_only').hide();
  };

  LayerHandler.prototype.hideMaskingButtons = function () {
    $('.masking_button.delete').hide();
    $('.masking_button.door_only').not(':first').show();
  };

  function getScaledPoint(point) {
    var scale = Renoworks.ProjectController.getScale();

    var x = parseInt(point.x);
    var y = parseInt(point.y);

    var position = $('.project_image').css('background-position').split(' ');

    if (position.length == 2) {
      var offsetX = parseInt(position[0].split('px')[0]) - parseInt($('.project_image').css('left').replace('px', ''));
      var offsetY = parseInt(position[1].split('px')[0]) - parseInt($('.project_image').css('top').replace('px', ''));

      var newX = (x * scale) + offsetX;
      var newY = (y * scale) + offsetY;
    } else {
      var newX = x;
      var newY = y;
    }

    return {
      x: newX,
      y: newY,
    };
  }
}(jQuery));
